function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "chrome - FontAwesome");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "1:-Tech-Check",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "BrowserCheckFailure",
  transform: "translate(-602.000000, -597.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Willing/molecules/wandaBlocks/m_wandaBlock_center",
  transform: "translate(395.000000, 217.000000)"
}, React.createElement("g", {
  id: "Group-29",
  transform: "translate(184.000000, 358.000000)"
}, React.createElement("g", {
  id: "Group-22"
}, React.createElement("path", {
  d: "M40.9397535,22.0003766 C44.0134179,21.9802872 47.1473502,22.7637703 50.0000322,24.4110937 C53.1540538,26.2392209 55.5446817,28.8709205 57.0714692,31.8843169 L42.1652014,31.1008338 C37.9464464,30.8597621 33.9285845,33.2303007 32.5424221,37.207984 L26.9977726,28.6901167 C30.4531339,24.3910044 35.6361758,22.0204659 40.9397535,22.0003766 Z M25.9330392,30.136547 L32.7031366,43.4557593 C34.611621,47.2124602 38.6495722,49.5026415 42.8281486,48.7191584 L38.2076074,57.7794371 C29.5892936,56.4535426 23,49.0004087 23,40.000398 C23,36.364233 24.0848227,32.9691396 25.9330392,30.136547 Z M57.7946843,33.5316403 C60.948706,41.6477214 57.7946843,51.0896969 50.0000322,55.5897023 C46.8460106,57.4178295 43.37056,58.1611339 39.995556,57.9803302 L48.1317264,45.4646902 C50.441997,41.9088824 50.4018184,37.2682519 47.649583,34.0539624 L57.7946843,33.5316403 Z M41.0000215,33.9334265 C44.3549362,33.9334265 47.066993,36.6454833 47.066993,40.000398 C47.066993,43.3553127 44.3549362,46.0673695 41.0000215,46.0673695 C37.6451067,46.0673695 34.9330499,43.3553127 34.9330499,40.000398 C34.9330499,36.6454833 37.6451067,33.9334265 41.0000215,33.9334265 Z",
  id: "chrome---FontAwesome"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/icon-chrome.a9edca7f.svg";
export { SvgComponent as ReactComponent };